import Token from './token'
import Form from './form'

export default {
  icon: 'volume-up',
  label: 'Speak Text',
  type: 'voice',
  action: 'say',
  form: Form,
  token: Token
}
